// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/landingPageImages/windwill.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_main_footer__QgS2m {
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  height: auto;

  .footer_footer__EGObk {
    padding: 7rem;
    display: flex;
    justify-content: space-between;
  }

  .footer_right_section__h7dst {
    width: 50%;
    margin: 1rem 0 0 1rem;

    & p {
      padding: 1.2rem 0;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.97rem;
      font-weight: 500;
    }

    .footer_inputSec__vjN7O {
      width: auto;
      display: flex;

      & input {
        display: flex;
        width: 250px;
        height: 50px;
        padding: 16px 17px;
        align-items: center;
        gap: 10px;
        border: none;
        border-radius: 5px 0px 0px 5px;
        background: var(--text-color);
      }

      & input::placeholder {
        font-size: 0.87rem;
        font-family: inter;
      }

      & button {
        color: #fff;
        font-family: Inter;
        font-size: 0.9rem;
        font-weight: 500;
        display: flex;
        width: 103px;
        height: 50px;
        gap: 10px;
        border: none;
        padding: 16px 34px;
        justify-content: center;
        align-items: center;
        border-radius: 0px 5px 5px 0px;
        background: var(--primary-color);
      }
    }
  }

  .footer_icon_section__hZ9a0 {
    margin-top: 6rem;

    & p {
      padding: 0;
      margin: 0;
    }
    .footer_icon__P4IwJ {
      margin-right: 0.6rem;
      font-size: 1.2rem;
      color: var(--text-color);
    }
  }

  .footer_left_section__EcnAc {
    margin-top: 1rem;
    width: 40%;

    & h6 {
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.97rem;
      font-weight: 700;
    }

    & ul {
      padding: 0;
    }

    & li {
      padding: 0.2rem 0;
      list-style: none;
    }

    & a {
      text-decoration: none;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }

    & a:hover {
      text-decoration: underline;
    }
    & p {
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.9rem;
      font-weight: 400;
    }
  }
}

.footer_bottom_footer__XHyMn {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--text-color);

  & p {
    padding: 0.6rem 0;
    color: var(--text-color);
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

/* -------media-queries----------- */

@media screen and (max-width: 568px) {
  .footer_main_footer__QgS2m {
    .footer_footer__EGObk {
      flex-direction: column;
      padding: 0;
    }

    .footer_right_section__h7dst {
      width: 95%;

      & p {
        padding: 1rem 0 1rem 0;
      }
    }

    .footer_left_section__EcnAc {
      padding-left: 2rem;
      width: 100%;
    }

    .footer_inputSec__vjN7O {
      width: 50% !important;

      & input {
        width: 200px !important;
      }
    }

    .footer_icon_section__hZ9a0 {
      margin: 1rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer/footer.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yDAAsE;EACtE,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;;EAEZ;IACE,aAAa;IACb,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,qBAAqB;;IAErB;MACE,iBAAiB;MACjB,wBAAwB;MACxB,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,aAAa;;MAEb;QACE,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,SAAS;QACT,YAAY;QACZ,8BAA8B;QAC9B,6BAA6B;MAC/B;;MAEA;QACE,kBAAkB;QAClB,kBAAkB;MACpB;;MAEA;QACE,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,SAAS;QACT,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;QACnB,8BAA8B;QAC9B,gCAAgC;MAClC;IACF;EACF;;EAEA;IACE,gBAAgB;;IAEhB;MACE,UAAU;MACV,SAAS;IACX;IACA;MACE,oBAAoB;MACpB,iBAAiB;MACjB,wBAAwB;IAC1B;EACF;;EAEA;IACE,gBAAgB;IAChB,UAAU;;IAEV;MACE,wBAAwB;MACxB,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,qBAAqB;MACrB,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;IAC5B;IACA;MACE,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;;EAEvC;IACE,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE;MACE,sBAAsB;MACtB,UAAU;IACZ;;IAEA;MACE,UAAU;;MAEV;QACE,sBAAsB;MACxB;IACF;;IAEA;MACE,kBAAkB;MAClB,WAAW;IACb;;IAEA;MACE,qBAAqB;;MAErB;QACE,uBAAuB;MACzB;IACF;;IAEA;MACE,YAAY;IACd;EACF;AACF","sourcesContent":[".main_footer {\n  width: 100%;\n  background-image: url(\"/public/images/landingPageImages/windwill.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: auto;\n\n  .footer {\n    padding: 7rem;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .right_section {\n    width: 50%;\n    margin: 1rem 0 0 1rem;\n\n    & p {\n      padding: 1.2rem 0;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.97rem;\n      font-weight: 500;\n    }\n\n    .inputSec {\n      width: auto;\n      display: flex;\n\n      & input {\n        display: flex;\n        width: 250px;\n        height: 50px;\n        padding: 16px 17px;\n        align-items: center;\n        gap: 10px;\n        border: none;\n        border-radius: 5px 0px 0px 5px;\n        background: var(--text-color);\n      }\n\n      & input::placeholder {\n        font-size: 0.87rem;\n        font-family: inter;\n      }\n\n      & button {\n        color: #fff;\n        font-family: Inter;\n        font-size: 0.9rem;\n        font-weight: 500;\n        display: flex;\n        width: 103px;\n        height: 50px;\n        gap: 10px;\n        border: none;\n        padding: 16px 34px;\n        justify-content: center;\n        align-items: center;\n        border-radius: 0px 5px 5px 0px;\n        background: var(--primary-color);\n      }\n    }\n  }\n\n  .icon_section {\n    margin-top: 6rem;\n\n    & p {\n      padding: 0;\n      margin: 0;\n    }\n    .icon {\n      margin-right: 0.6rem;\n      font-size: 1.2rem;\n      color: var(--text-color);\n    }\n  }\n\n  .left_section {\n    margin-top: 1rem;\n    width: 40%;\n\n    & h6 {\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.97rem;\n      font-weight: 700;\n    }\n\n    & ul {\n      padding: 0;\n    }\n\n    & li {\n      padding: 0.2rem 0;\n      list-style: none;\n    }\n\n    & a {\n      text-decoration: none;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n\n    & a:hover {\n      text-decoration: underline;\n    }\n    & p {\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.9rem;\n      font-weight: 400;\n    }\n  }\n}\n\n.bottom_footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid var(--text-color);\n\n  & p {\n    padding: 0.6rem 0;\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n}\n\n/* -------media-queries----------- */\n\n@media screen and (max-width: 568px) {\n  .main_footer {\n    .footer {\n      flex-direction: column;\n      padding: 0;\n    }\n\n    .right_section {\n      width: 95%;\n\n      & p {\n        padding: 1rem 0 1rem 0;\n      }\n    }\n\n    .left_section {\n      padding-left: 2rem;\n      width: 100%;\n    }\n\n    .inputSec {\n      width: 50% !important;\n\n      & input {\n        width: 200px !important;\n      }\n    }\n\n    .icon_section {\n      margin: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_footer": `footer_main_footer__QgS2m`,
	"footer": `footer_footer__EGObk`,
	"right_section": `footer_right_section__h7dst`,
	"inputSec": `footer_inputSec__vjN7O`,
	"icon_section": `footer_icon_section__hZ9a0`,
	"icon": `footer_icon__P4IwJ`,
	"left_section": `footer_left_section__EcnAc`,
	"bottom_footer": `footer_bottom_footer__XHyMn`
};
export default ___CSS_LOADER_EXPORT___;
